import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import loginimg from "../../Assets/Images/forget.png";
import logo from "../../Assets/Images/site_logo.png";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { USER_BASE_URL, OTP, RESENDOTP } from "../../API";
import OtpInput from "react-otp-input";

function Otp() {
  const [otpCode, setOtpCode] = useState("");
  const [focusedIndex, setFocusedIndex] = useState(null);
  const [timer, setTimer] = useState(59);
  const [sendOTP, setSendOTP] = useState(true);
  const activeBorderColor = "#0195F7";
  const filledBorderColor = "#0195F74D";
  const pendingBorderColor = "#9B9B9B4D";
  const location = useLocation();
  const [email, setEmail] = useState(location?.state?.data);
  const { handleSubmit, formState: { errors }, setValue, } = useForm();
  const navigate = useNavigate();
  const renderInput = (props, index) => {
    const isFilled = otpCode[index] !== undefined;
    const isFocused = focusedIndex === index;
    return (
      <input
        {...props}
        onFocus={() => setFocusedIndex(index)}
        onBlur={() => setFocusedIndex(null)}
        className="otp_input_box"
        style={{
          border: `2px solid 
          ${isFocused ?
              activeBorderColor
              :
              isFilled ? filledBorderColor : pendingBorderColor
            }`,
          color: "#000",
          textAlign: "center",
          outline: "none",
          caretColor: "#000",
          boxSizing: "border-box",
          transition: "border 0.2s ease",
        }}
      />
    );
  };

  useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    setValue("email", storedEmail);
  }, [setValue]);

  useEffect(() => {
    let timerId;
    if (!sendOTP && timer > 0) { timerId = setInterval(() => { setTimer((prevTimer) => prevTimer - 1) }, 1000); }
    if (timer === 0) { setSendOTP(true) }

    return () => clearInterval(timerId);
  }, [sendOTP, timer]);

  const handleResendClick = async () => {
    if (!sendOTP) return;
    setSendOTP(false);
    setTimer(59);
    try {
      const response = await axios.post(USER_BASE_URL + RESENDOTP, { language: 'ENGLISH', email: email });
      toast.success("OTP has been resent successfully.");
    }
    catch (error) {
      toast.error(error.response?.data?.error_message || "Failed to resend OTP.");
      setSendOTP(true);
    }
  };

  const submitHandler = async (data) => {
    data.language = "ENGLISH";
    data.email = email;
    data.otp = otpCode;
    try {
      const response = await axios.post(USER_BASE_URL + OTP, data);
      const userToken = response.data.data.access_token;
      localStorage.setItem("userToken", userToken);
      if (response.status === 200) {
        toast.success('OTP verified successfully.');
        navigate('/', { replace: true });
      }
    }
    catch (error) { toast.error(error.response?.data?.error_message || error.response?.data?.error_description || "Failed to verify OTP.") }
  };

  return (
    <>
      <section className="login-section">
        <div className="container-fluid g-0">
          {/* <Header /> */}
          <Row className="row-min-h">
            <Col lg={6} className="img-n">
              <div className="upper-fig-main-login">
                <figure className="login-img-main"><img src={loginimg} alt="" /></figure>
              </div>
            </Col>
            <Col lg={6}>
              <div className="inner-login-mian">
                <div className="loginupper-right otp">
                  <figure className="creden_page_logo"> <img src={logo} alt="" className="img-fluid" /></figure>
                  <h2>Two Factor authentication</h2>
                  <p className="auth_page_sub_heading">
                    Enter the verification code sent to your email to complete 2FA. This extra step secures your account.
                  </p>
                  <Form onSubmit={handleSubmit(submitHandler)}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <OtpInput
                        value={otpCode}
                        onChange={setOtpCode}
                        numInputs={6}
                        inputType="number"
                        autoFocus
                        renderInput={renderInput}
                        separator={<span style={{ width: "8px" }} />}
                      />
                    </div>
                    <div className="auth-bottom-link-sec">
                      <p>Didn't get the code?
                        {sendOTP ?
                          <Link onClick={handleResendClick}>Resend It</Link>
                          :
                          <span style={{ color: "#9B9B9B" }}>Wait {timer} second{timer !== 1 ? 's' : ''} to resend OTP.</span>
                        }
                      </p>
                    </div>
                    <Button className="login-btn" type="submit">Submit</Button>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}
export default Otp;